export const scrollToStart = (container) => {
    container.scrollTo({ left: 0, behavior: 'smooth' });
};
//# sourceMappingURL=scrollToStart.js.map